import { COSIGN_TOKEN_KEY } from '@constants'
import { useEffectOnce } from '@dni-react-hooks/use-effect-once'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom-v5'
import { useCampaign } from '../../hooks/use-campaign'
import useLanguage from '../../hooks/use-language'
import { setExhibitorSettings } from '../../store/reducer/client-reducer'
import { RefreshCosignToken } from '../merchant/MerchantLogin/RefreshCosignToken'
import AdminChecked from './admin-checked'
import { AdminLogin } from './admin-login'
import AdminOrderCheck from './admin-order-check'
import AdminReview from './admin-review'
import AdminScan from './admin-scan'

const NoneLoginRedirect = ({ page }: { page: React.ReactNode }) => {
  const adminToken = JSON.parse(sessionStorage.getItem('admin') || '{}')
  const { campaignCodeFromUrl } = useCampaign()
  if (typeof adminToken.token === 'undefined') {
    return <Redirect to={`/admin/${campaignCodeFromUrl}/admin-login`} />
  }

  return <>{page}</>
}

const MemberLoginRedirect = ({ page }: { page: React.ReactNode }) => {
  const adminToken = JSON.parse(sessionStorage.getItem('admin') || '{}')
  const { campaignCodeFromUrl } = useCampaign()
  if (typeof adminToken.token === 'undefined' && !Cookies.get(`${campaignCodeFromUrl}_${COSIGN_TOKEN_KEY}`)) {
    return <Redirect to={{ pathname: `/campaigns/${campaignCodeFromUrl}/login`, state: { referrer: `${window.location.origin}/admin/${campaignCodeFromUrl}/admin-login` } }} />
  }

  return <>{page}</>
}

export function AdminRouters() {
  const dispatch = useDispatch()
  const { campaignCodeFromUrl } = useCampaign()

  useApiCampaignActivityInfo(campaignCodeFromUrl, {
    onSuccess: ({ data }) => {
      dispatch(setExhibitorSettings(data.data))
    },
  })
  useEffectOnce(() => {
    document.title = 'Buygather - 工作人員後台'
  })

  const { changeLanguage } = useLanguage()

  useEffect(() => {
    changeLanguage('zh-TW')
  }, [changeLanguage])

  return (
    <Switch>
      <Route exact path="/admin/:campaignID/admin-login">
        <MemberLoginRedirect page={<><RefreshCosignToken /><AdminLogin /></>} />
      </Route>
      <Route exact path="/admin/:campaignID/admin-scan"><NoneLoginRedirect page={<AdminScan />} /></Route>
      <Route exact path="/admin/:campaignID/admin-review/:orderId"><NoneLoginRedirect page={<AdminReview />} /></Route>
      <Route exact path="/admin/:campaignID/admin-checked"><NoneLoginRedirect page={<AdminChecked />} /></Route>
      <Route exact path="/admin/:campaignID/admin-order-check/:orderId"><NoneLoginRedirect page={<AdminOrderCheck />} /></Route>
    </Switch>
  )
}
